<div
  class="fixed bottom-5 z-[1100]"
  [style.left]="'calc(50% - 350px)'"
  [ngClass]="{ hidden: !show, block: show }"
>
  <div
    class="rounded-md px-7 py-7 bg-primary text-white flex flex-col mx-auto relative w-[700px]"
  >
    <div class="w-full flex justify-end absolute top-0 left-0">
      <confect-icon-button
        icon="clear"
        iconClass="text-lg hover:opacity-80 mr-2"
        (click)="show = false"
      />
    </div>
    <div class="flex items-center">
      <div>
        A newer version of Confect is now available! Refresh to get the latest
        version.
      </div>
      <div class="flex flex-grow shrink-0">
        <span class="ml-2 font-bold cursor-pointer" (click)="refresh()">
          <confect-icon icon="refresh" iconClass="text-lg mr-1 "
            ><span class="underline">Update Now</span></confect-icon
          >
        </span>
      </div>
    </div>
  </div>
</div>
